<template>
<div >
    {{ ivr_shop_type }}
</div>
</template>

<script>
import Vue from 'vue'
import { IvrTypeStr } from "@/constants/IvrShopType";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        ivr_shop_type() {
            return IvrTypeStr.get(this.row.ivr_shop_type)
        },
    }
})
</script>

<style>

</style>